import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import axios from "axios";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import CardTopFive from "../../atoms/card-top-five/cardTopFive";
import TopFiveSlider from "../../molecules/top-five-slider/topFiveSlider";

import "./topFive.scss";

const TopFive = (props: ReferenciaContenido) => {
  const contentfulData = useStaticQuery(graphql`
    query QueryTopConversations {
      allContentfulHome(filter: { titulo: { eq: "Home bibliotecas" } }) {
        nodes {
          referenciaConversaciones {
            imagenPrincipal {
              title
              file {
                url
              }
            }
            tituloBanner
            redireccionBoton
            descripcion {
              raw
            }
          }
        }
      }
    }
  `);

  const [conversations, setConversations] = useState<any[]>([]);

  useEffect(() => {
    getConversations();
  }, []);

  const contentfulConversations = contentfulData.allContentfulHome.nodes[0]
    .referenciaConversaciones;

  const getConversations = async () => {
    const tribeData = await axios.get(`${process.env.URL_BIBLIOTECAS_SERVICES}/community/api/v1/post-top?size=5`);
    if (tribeData.data.data) {
      const conversations: any[] = [];
      tribeData.data.data.map(element => {
        let conversation = [...contentfulConversations].find(contConv => contConv.tituloBanner === element.id);
        conversation.comments = element.responses;
        conversations.push(conversation);
      })
      setConversations(conversations);
    }
  }

  return (
    <div className="o-top-five">
      <h2 className="o-top-five__title">{props.tituloGeneral}</h2>
      <div className="o-top-five__desk">
        {conversations.map((conversation, idx) => {
          return (
            <CardTopFive
              conversation={conversation}
              number={idx + 1}
              key={idx}
            />
          );
        })}
      </div>

      <div className="o-top-five__mobile">
        <TopFiveSlider conversations={conversations} />
      </div>
    </div>
  );
};

export default TopFive;
